import React, { useEffect, useRef } from 'react'

export const SearchModal = ({ children, open, onBackdropClicked, id }) => {
  const modalRef = useRef()

  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp)

    return () => {
      document.removeEventListener('keyup', handleKeyUp)
    }
  }, [open])

  const handleKeyUp = e => {
    if (open && e.key === 'Escape') {
      onBackdropClicked()
    }
  }

  const handleBlur = e => {
    // This is a bit of a hack to solve for an edge case where we render this over another modal.
    // For some reason the existing modal backdrop causes blur events to fire even when clicking
    // inside this modal, so we code an exception for it here
    if (e.relatedTarget != null && e.relatedTarget.id !== 'modal') {
      const focusIsContained = modalRef.current?.contains(e.relatedTarget)
      if (!focusIsContained) onBackdropClicked()
    }
  }

  const modalClass = `search-modal ${open ? 'open' : ''}`

  return (
    <>
      <div
        ref={modalRef}
        className={modalClass}
        style={{ viewTransitionName: `search-modal-${id}` }}
        onBlur={handleBlur}
      >
        {children}
      </div>
      {open && <div className={'modal-backdrop show'} onClick={onBackdropClicked} onKeyUp={handleKeyUp} />}
    </>
  )
}
